module.exports = __webpack_public_path__ + "static/media/logo-bus-eireann.49cff58b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/logo-bus-eireann.svg
// module id = 159
// module chunks = 0